import { gql } from 'graphql-request';

export const CACHE_CREATE_CUSTOM_FIELD_QUERY = gql`
  mutation CacheCreateCustomField(
    $body: String
    $checkedAt: DateTime
    $companyId: ID
    $label: String!
    $location: String!
    $options: Json
    $order: Int
  ) {
    createCustomField(
      input: {
        body: $body
        checkedAt: $checkedAt
        companyUuid: $companyId
        label: $label
        location: $location
        options: $options
        order: $order
      }
    ) {
      errors {
        fullMessages
      }
      record {
        body
        checkedAt
        companyId
        createdAt
        customFieldValues {
          companyId
          createdAt
          customFieldId
          defaultAt
          id
          text
          updatedAt
          uuid
        }
        id
        label
        location
        options
        updatedAt
        userId
        uuid
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
